export default __webpack_public_path__ + "static/media/calendar.a008e606.svg";